import startsWith from 'lodash/startsWith'
import { routesList } from '../routes'

export const getCurrentRouteByLocation = (pathname: string) => {
  return routesList.find(
    (route) =>
      (startsWith(route.path, '/') ? route.path : `/${route.path}`) === pathname
  )
}
